
export const mapEntityResponse = (resp) => {

  const mapped = {
        exportEntityName: resp.exportEntityName || null,
        exportEntityCountry: resp.exportEntityCountry || null,
        exportEntityState: resp.exportEntityState || null,
        exportEntityCity: resp.exportEntityCity || null,
        exportEntityPostalCode: resp.exportEntityPostalCode || null,
        exportEntityAddressLine: resp.exportEntityAddressLine || null,
        exportEntityTelephone: resp.exportEntityTelephone || null,
        exportEntityType: resp.exportEntityType || null,
        exportEntityFax: resp.exportEntityFax || null,
        exportEntityContactPerson: resp.exportEntityContactPerson || null,
        exportEntityEmail: resp.exportEntityEmail || null,
        exportEntityMobile: resp.exportEntityMobile || null,
        exportEntityAddress : resp.exportEntityState || null,
        id: resp.exportEntityId,
    };
    return mapped;

  }

  
  // export const mapEntityResponse = (resp) => {
  //   const normalizeEntity = (val) => {
  //     if (!val) return null;
  //     if (typeof val === "object") return val; // already correct shape
  //     return { id: val, name: String(val) }; // fallback for string IDs
  //   };
  
  //   const mapped = {
  //     exportEntityName: normalizeEntity(resp.exportEntityName),
  //     exportEntityCountry: normalizeEntity(resp.exportEntityCountry),
  //     exportEntityState: normalizeEntity(resp.exportEntityState),
  //     exportEntityCity: normalizeEntity(resp.exportEntityCity),
  //     exportEntityPostalCode: normalizeEntity(resp.exportEntityPostalCode),
  //     exportEntityAddressLine: resp.exportEntityAddressLine || null,
  //     exportEntityTelephone: resp.exportEntityTelephone || null,
  //     exportEntityType: resp.exportEntityType || null,
  //     exportEntityFax: resp.exportEntityFax || null,
  //     exportEntityContactPerson: resp.exportEntityContactPerson || null,
  //     exportEntityEmail: resp.exportEntityEmail || null,
  //     exportEntityMobile: resp.exportEntityMobile || null,
  //     exportEntityStatus: resp.exportEntityStatus || null,
  //     exportEntityAddress: normalizeEntity(resp.exportEntityState),
  //     id: resp.exportEntityId,
  //   };
  
  //   console.log("✅ [mapEntityResponse] Mapped Entity:", mapped);
  //   alert("2121313")
  //   return mapped;
  // };
  